import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Checkbox from "material-ui/Checkbox";
import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  FormLabel
} from "material-ui/Form";
import Typography from "material-ui/Typography";
import { withStyles } from "material-ui/styles";
import TextField from "material-ui/TextField";
import Table from "../../../table";
import styles from "./styles";
import NoData from "../../../nodata";
import { Link } from "react-router-dom";
import STWiremapDiagram from "../stdiagram";
import { validateFormData } from "../../../../common/formtool";
import { ModalHeader, ModalContents, ModalFooter } from "../../../common/modal";

class AddCable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editSaving: false,
      errors: {},
      selected: {},
      error: null,
      pinList: [],
      isChanged: false,
      cableName: "Cable 1",
      cableDetail: props.isEdit
        ? this.cableDetailOnEdit(props.cableDetail)
        : props.cableDetail,
      isAdd: props.isAdd,
      isEdit: props.isEdit,
      isMinPinError: false,
      pinPairs: ["1,2", "3,6", "4,5", "7,8"]
    };
    this.handleClose = this.handleClose.bind(this);
    this.onCheckBoxChange = this.onCheckBoxChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  cableDetailOnEdit(cableDetail) {
    if (
      (cableDetail.Details[0].IsThru == true &&
        cableDetail.Details[1].IsThru == false) ||
      (cableDetail.Details[0].IsThru == false &&
        cableDetail.Details[1].IsThru == true)
    ) {
      cableDetail.Details[0].IsThru = false;
      cableDetail.Details[0].IsOpen = true;
      cableDetail.Details[1].IsThru = false;
      cableDetail.Details[1].IsOpen = true;
    }
    if (
      (cableDetail.Details[2].IsThru == true &&
        cableDetail.Details[5].IsThru == false) ||
      (cableDetail.Details[2].IsThru == false &&
        cableDetail.Details[5].IsThru == true)
    ) {
      cableDetail.Details[2].IsThru = false;
      cableDetail.Details[2].IsOpen = true;
      cableDetail.Details[5].IsThru = false;
      cableDetail.Details[5].IsOpen = true;
    }
    if (
      (cableDetail.Details[3].IsThru == true &&
        cableDetail.Details[4].IsThru == false) ||
      (cableDetail.Details[3].IsThru == false &&
        cableDetail.Details[4].IsThru == true)
    ) {
      cableDetail.Details[3].IsThru = false;
      cableDetail.Details[3].IsOpen = true;
      cableDetail.Details[4].IsThru = false;
      cableDetail.Details[4].IsOpen = true;
    }
    if (
      (cableDetail.Details[6].IsThru == true &&
        cableDetail.Details[7].IsThru == false) ||
      (cableDetail.Details[6].IsThru == false &&
        cableDetail.Details[7].IsThru == true)
    ) {
      cableDetail.Details[6].IsThru = false;
      cableDetail.Details[6].IsOpen = true;
      cableDetail.Details[7].IsThru = false;
      cableDetail.Details[7].IsOpen = true;
    }
    return cableDetail;
  }

  handleClose() {
    this.setState({
      isAdd: false,
      isEdit: false
    });
    this.props.onClose();
  }

  handleSubmit() {
    let cableDetail = { ...this.state.cableDetail };
    let { translate } = this.props;
    this.setState(
      {
        isChanged: true
      },
      () => {
        let vObj = {
          name: {
            required: translate("formfield_error_general_required"),
            maxCharacter: {
              length: 15,
              message: translate("subtest_target_length_validation", {
                value: 15
              })
            }
          }
        };
        let errors = validateFormData(cableDetail, vObj);
        const missingFieldName = Object.keys(errors)[0];
        if (missingFieldName) {
          const textField = document.getElementsByName(missingFieldName)[0];
          textField && textField.focus();
        }
        if (Object.keys(errors).length) {
          this.setState({ errors: errors, ischanged: false });
        } else {
          let self = this;
          if (this.props.isAdd) {
            if (this.state.pinList.length < 2) {
              this.setState({
                isMinPinError: true
              });
            } else {
              this.props.onCableAddSubmit(
                this.state.pinList,
                this.state.cableDetail.name,
                this.state.cableDetail.id
              );
              this.setState({
                pinList: []
              });
            }
          } else {
            if (
              this.state.cableDetail.Details.filter(ele => ele.IsThru == true)
                .length < 3
            ) {
              this.setState({
                isMinPinError: true
              });
            } else {
              this.props.onCableAddSubmit(
                this.state.pinList,
                this.state.cableDetail.name,
                this.state.cableDetail.id
              );
              this.setState({
                pinList: []
              });
            }
          }
        }
        this.setState({
          isAdd: false,
          isEdit: false
        });
      }
    );
  }

  onTextChange = e => {
    let cableDetail = { ...this.state.cableDetail };
    let { errors } = this.state;
    var xyz = this.state.pinList;
    cableDetail.name = e.target.value;
    errors[e.target.name] = false;
    this.setState({
      cableDetail,
      errors,
      isChanged: true
    });
    if (!this.props.isAdd) {
      let pinList = [];
      let newdata = cableDetail.Details.map(x => {
        x.IsThru ? pinList.push(Number(x.DHPin)) : null;
      });
      this.setState({
        pinList
      });
    }
  };

  onCheckBoxChange = e => {
    let cableDetail = { ...this.state.cableDetail };
    let pinList = [...this.state.pinList];
    if (this.props.isAdd) {
      if (e.target.checked == true) {
        if (e.target.value == "") {
          cableDetail.Details[0].IsThru = true;
          cableDetail.Details[0].IsOpen = false;
          cableDetail.Details[1].IsThru = true;
          cableDetail.Details[1].IsOpen = false;
          pinList.push(1, 2);
        } else if (e.target.value == "1") {
          cableDetail.Details[2].IsThru = true;
          cableDetail.Details[2].IsOpen = false;
          cableDetail.Details[5].IsThru = true;
          cableDetail.Details[5].IsOpen = false;
          pinList.push(3, 6);
        } else if (e.target.value == "2") {
          cableDetail.Details[3].IsThru = true;
          cableDetail.Details[3].IsOpen = false;
          cableDetail.Details[4].IsThru = true;
          cableDetail.Details[4].IsOpen = false;
          pinList.push(4, 5);
        } else if (e.target.value == "3") {
          cableDetail.Details[6].IsThru = true;
          cableDetail.Details[6].IsOpen = false;
          cableDetail.Details[7].IsThru = true;
          cableDetail.Details[7].IsOpen = false;
          pinList.push(7, 8);
        }
      } else {
        if (e.target.value == "") {
          cableDetail.Details[0].IsThru = false;
          cableDetail.Details[0].IsOpen = true;
          cableDetail.Details[1].IsThru = false;
          cableDetail.Details[1].IsOpen = true;
          pinList = pinList.filter(function(item) {
            return item !== 1 && item !== 2;
          });
        } else if (e.target.value == "1") {
          cableDetail.Details[2].IsThru = false;
          cableDetail.Details[2].IsOpen = true;
          cableDetail.Details[5].IsThru = false;
          cableDetail.Details[5].IsOpen = true;
          pinList = pinList.filter(function(item) {
            return item !== 3 && item !== 6;
          });
        } else if (e.target.value == "2") {
          cableDetail.Details[3].IsThru = false;
          cableDetail.Details[3].IsOpen = true;
          cableDetail.Details[4].IsThru = false;
          cableDetail.Details[4].IsOpen = true;
          pinList = pinList.filter(function(item) {
            return item !== 4 && item !== 5;
          });
        } else if (e.target.value == "3") {
          cableDetail.Details[6].IsThru = false;
          cableDetail.Details[6].IsOpen = true;
          cableDetail.Details[7].IsThru = false;
          cableDetail.Details[7].IsOpen = true;
          pinList = pinList.filter(function(item) {
            return item !== 7 && item !== 8;
          });
        }
      }
      this.setState({
        cableDetail,
        pinList,
        isChanged: true,
        isMinPinError: false
      });
    } else {
      let newdata = cableDetail.Details.map(x => {
        x.IsThru ? pinList.push(Number(x.DHPin)) : null;
      });
      //this.props.onCheckBoxChange(e.target.id);
      if (e.target.checked == true) {
        if (e.target.value == "") {
          cableDetail.Details[0].IsThru = true;
          cableDetail.Details[0].IsOpen = false;
          cableDetail.Details[1].IsThru = true;
          cableDetail.Details[1].IsOpen = false;
          pinList.push(1, 2);
        } else if (e.target.value == "1") {
          cableDetail.Details[2].IsThru = true;
          cableDetail.Details[2].IsOpen = false;
          cableDetail.Details[5].IsThru = true;
          cableDetail.Details[5].IsOpen = false;
          pinList.push(3, 6);
        } else if (e.target.value == "2") {
          cableDetail.Details[3].IsThru = true;
          cableDetail.Details[3].IsOpen = false;
          cableDetail.Details[4].IsThru = true;
          cableDetail.Details[4].IsOpen = false;
          pinList.push(4, 5);
        } else if (e.target.value == "3") {
          cableDetail.Details[6].IsThru = true;
          cableDetail.Details[6].IsOpen = false;
          cableDetail.Details[7].IsThru = true;
          cableDetail.Details[7].IsOpen = false;
          pinList.push(7, 8);
        }
      } else {
        if (e.target.value == "") {
          cableDetail.Details[0].IsThru = false;
          cableDetail.Details[0].IsOpen = true;
          cableDetail.Details[1].IsThru = false;
          cableDetail.Details[1].IsOpen = true;
          pinList = pinList.filter(function(item) {
            return item !== 1 && item !== 2;
          });
        } else if (e.target.value == "1") {
          cableDetail.Details[2].IsThru = false;
          cableDetail.Details[2].IsOpen = true;
          cableDetail.Details[5].IsThru = false;
          cableDetail.Details[5].IsOpen = true;
          pinList = pinList.filter(function(item) {
            return item !== 3 && item !== 6;
          });
        } else if (e.target.value == "2") {
          cableDetail.Details[3].IsThru = false;
          cableDetail.Details[3].IsOpen = true;
          cableDetail.Details[4].IsThru = false;
          cableDetail.Details[4].IsOpen = true;
          pinList = pinList.filter(function(item) {
            return item !== 4 && item !== 5;
          });
        } else if (e.target.value == "3") {
          cableDetail.Details[6].IsThru = false;
          cableDetail.Details[6].IsOpen = true;
          cableDetail.Details[7].IsThru = false;
          cableDetail.Details[7].IsOpen = true;
          pinList = pinList.filter(function(item) {
            return item !== 7 && item !== 8;
          });
        }
      }
      this.setState({
        cableDetail,
        pinList,
        isChanged: true,
        isMinPinError: false
      });
    }
  };
  isChecked = key => {
    const { cableDetail } = this.state;
    let status;

    if (key == 0)
      status =
        cableDetail.Details[0].IsThru && cableDetail.Details[1].IsThru
          ? true
          : false;
    else if (key == 1)
      status =
        cableDetail.Details[2].IsThru && cableDetail.Details[5].IsThru
          ? true
          : false;
    else if (key == 2)
      status =
        cableDetail.Details[3].IsThru && cableDetail.Details[4].IsThru
          ? true
          : false;
    else if (key == 3)
      status =
        cableDetail.Details[6].IsThru && cableDetail.Details[7].IsThru
          ? true
          : false;

    return status;
  };

  selectedRows = rows => {
    this.setState({
      selected: rows
    });
  };
  render() {
    const {
      languages,
      modal,
      translate,
      classes,
      isAdd,
      isEdit,
      wiremapStandard
    } = this.props;
    //let { targetList } = this.props;
    const {
      cableDetail,
      errors,
      isChanged,
      isMinPinError,
      pinPairs
    } = this.state;

    //const _selected = { ...selected };
    const columns = [];

    columns.push({
      id: "url",
      accessor: d => d["url"],
      Cell: o => (
        <div style={{ textAlign: "left", paddingLeft: 40 }}>{o.value}</div>
      )
    });
    columns.push({
      id: "id",
      accessor: d => d["id"],
      show: false
    });
    //targetList = targetList.filter(item => item.url != null);
    return (
      <Modal open={modal} onClose={this.handleClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography
                type="headline"
                color="inherit"
                className={classes.modalHeader}
              >
                {isAdd == true
                  ? translate(
                      "general_sub_test_wiremap_modal_add_a_cust_cable_head"
                    )
                  : translate(
                      "general_sub_test_wiremap_modal_edit_a_cust_cable_head"
                    )}
              </Typography>
              <Button className={classes.close} onClick={this.handleClose}>
                <Icon> clear </Icon>
              </Button>
            </ModalHeader>

            <div>
              <ModalContents className={classes.rootModal}>
                <TextField
                  className={classes.textField}
                  name="name"
                  label={translate("wiremap_cust_cab_header")}
                  error={errors && errors.name ? true : false}
                  margin="normal"
                  value={cableDetail.name}
                  onChange={this.onTextChange}
                  helperText={errors && errors.name ? errors.name : ""}
                  fullWidth
                />
                <table>
                  <tr>
                    <td style={{ paddingRight: "50px" }}>
                      <FormControl
                        component="fieldset"
                        className={classes.formControl}
                      >
                        {translate("general_pairs")}
                        {pinPairs &&
                          pinPairs.map((pair, key) => {
                            return (
                              pair && (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        isEdit == true
                                          ? this.isChecked(key)
                                          : null
                                      }
                                      value={key}
                                      onChange={this.onCheckBoxChange}
                                    />
                                  }
                                  label={pair}
                                />
                              )
                            );
                          })}
                      </FormControl>
                    </td>
                    <td>
                      <STWiremapDiagram
                        data={cableDetail}
                        translate={translate}
                        wiremapStandard={wiremapStandard}
                        isEdit={isEdit}
                        isAdd={isAdd}
                        onCheckBoxChange={this.onCheckBoxChange}
                      />
                    </td>
                  </tr>
                </table>
              </ModalContents>
              <ModalFooter>
                <div
                  className={isMinPinError == true ? classes.modalFooter : null}
                >
                  {isMinPinError == true && (
                    <Typography type="subheading" color="error">
                      {translate("min_pin_pair_selected_validation")}
                    </Typography>
                  )}
                  <Button
                    raised
                    color="primary"
                    className={classes.submit}
                    onClick={this.handleSubmit}
                    type="submit"
                    disabled={!isChanged}
                  >
                    {translate("sub_set_ping_select_target")}
                  </Button>
                </div>
              </ModalFooter>
            </div>
          </Paper>
        </div>
      </Modal>
    );
  }

  componentWillReceiveProps(nextProps) {
    //   const { editSaving } = this.state;
    //   const { customer } = nextProps;
    //   if (!editSaving) {
    //     if (customer) {
    //       this.setState({
    //         customer: { ...customer }
    //       });
    //       return;
    //     }
    //   }
    //   this.setState({
    //     customer: {
    //       ...this.state.customer,
    //       logo: customer ? customer.logo : null,
    //       logopath: customer ? customer.logopath : null
    //     }
    //   });
  }
}

export default withStyles(styles)(AddCable);
